import GeneralLayout from "../../../layouts/General"
import { TLBParagraphs } from "../../../app/utils/constants"
import { useEffect, useState } from "react"
import { theLoroBlonyoImgs } from "../../../app/utils/constants"
import clsx from "clsx"

const TheLoroBlonyo = () => {
  const [imgsLoaded, setImgsLoaded] = useState(false)

  useEffect(() => {
    const loadImage = image => {
      return new Promise((resolve, reject) => {
        const loadImg = new Image()
        loadImg.src = image

        loadImg.onload = () =>
          setTimeout(() => {
            resolve(image)
          }, 500)

        loadImg.onerror = err => reject(err)
      })
    }

    Promise.all(theLoroBlonyoImgs.map(image => loadImage(image)))
      .then(() => setImgsLoaded(true))
      .catch(err => console.log("Failed to load images", err))
  }, [])

  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <section className="bg-[url('/src/assets/imgs/our-story/the-loro-blonyo/section-cover.jpg')] bg-cover bg-center relative overflow-hidden max-md:pb-[330px] max-lg:pb-14">
          {!imgsLoaded && (
            <div className={clsx("h-full w-full absolute z-10", { "bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 transition-opacity animate-shimmer": !imgsLoaded })}></div>
          )}
          <div className={clsx("relative xs:w-[375px] sm:w-[640px] md:w-[768px] lg:w-[1024px] xl:w-[1280px] mx-autotransition-opacity", { "opacity-0": !imgsLoaded, "opacity-1": imgsLoaded })}>
            <img src={theLoroBlonyoImgs[0]} width="100" className="w-[1000px] relative -top-4 md:-top-8 left-[100px] sm:left-[250px] md:left-[350px]" />
            <img src={theLoroBlonyoImgs[1]} width="100" className="w-[700px] absolute top-10 lg:top-20 -left-14 sm:-left-24 lg:-left-10" />
            <img src={theLoroBlonyoImgs[2]} width="100" className="w-[950px] absolute -top-10 sm:-top-20 md:-top-28 sm:-left-12 lg:left-1/2 lg:-translate-x-1/2" />
            <img src={theLoroBlonyoImgs[3]} width="100" className="max-md:hidden w-[900px] absolute top-0 lg:-left-5 xl:left-20" />
            <img src={theLoroBlonyoImgs[3]} width="100" className="w-[900px] absolute -top-10 sm:-top-20 md:-top-28 lg:-top-24 left-[300px] sm:left-[450px] lg:left-[730px] -translate-x-1/2" />
            <div className="absolute top-16 lg:top-24 left-1/2 -translate-x-1/2 w-[760px] flex justify-center">
              <div>
                <img src={theLoroBlonyoImgs[4]} width="100" className="-z-10 absolute top-[270px] sm:top-40 xl:top-60 w-[380px] sm:w-[90%] lg:w-full" />
                <img src={theLoroBlonyoImgs[4]} width="100" className="w-[380px] sm:w-[90%] lg:w-full" />
              </div>
              <div className="absolute top-8 sm:top-16 lg:top-20 mx-auto">
                <h1 className="text-[#6e6059] font-light text-center sm:text-4xl lg:text-5xl xl:text-6xl"><span className="font-agcasmlt">The Loro Blonyo</span><span className="sm:text-3xl lg:text-4xl xl:text-5xl font-sloopScriptPro block">the inseparable couple</span></h1>
                <img src={theLoroBlonyoImgs[6]} width="100" className="mx-auto md:mt-2 w-[80px] sm:w-[150px] lg:w-[180px]" />
                <div className="w-[180px] sm:w-[310px] md:w-[380px] lg:w-[480px] xl:w-[500px]">
                  {TLBParagraphs.map((p, i) => (
                    <div key={i} className="font-americanTC text-[#6e6059] leading-[10px] sm:leading-3 xl:leading-[14px] text-[7.5px] sm:text-[10px] xl:text-xs mb-1 sm:mb-2 md:mb-4 text-center">{p}</div>
                  ))}
                </div>
              </div>
            </div>
            <img src={theLoroBlonyoImgs[5]} width="100" className="w-3.5 sm:w-7 xl:w-10 rotate-45 absolute top-[60px] md:top-12 lg:top-20 xl:top-16 left-[210px] xs:left-[220px] sm:left-[400px] md:left-[460px] lg:left-[620px] xl:left-[760px] -translate-x-1/2" />
            <img src={theLoroBlonyoImgs[7]} width="100" className="w-[130px] xs:w-[140px] sm:w-[240px] md:w-[280px] lg:w-[400px] xl:w-[550px] absolute top-[170px] sm:top-[300px] md:top-[270px] lg:top-[345px] xl:top-[300px] -left-5 xs:-left-5 sm:-left-12 lg:-left-[64px] xl:-left-[70px]" />
            <img src={theLoroBlonyoImgs[8]} width="100" className="w-[80px] sm:w-[170px] md:w-[180px] lg:w-[200px] xl:w-[250px] absolute top-[120px] sm:top-[170px] md:top-[150px] lg:top-[220px] xl:top-[200px] left-10 sm:left-14 md:left-20 lg:left-24 xl:left-60" />
            <img src={theLoroBlonyoImgs[9]} width="100" className="xs:w-[120px] sm:w-[200px] md:w-[230px] lg:w-[310px] xl:w-[380px] absolute top-32 sm:top-40 lg:top-36 right-0 xs:-right-3 sm:-right-5 lg:-right-2 xl:right-12" />
            <img src={theLoroBlonyoImgs[10]} width="100" className="xs:w-[120px] sm:w-[200px] md:w-[220px] lg:w-[300px] xl:w-[320px] absolute top-[280px] sm:top-[400px] lg:top-[480px] -right-2 xs:-right-3 sm:-right-5 md:-right-3 lg:right-0 xl:right-16" />
          </div>
        </section>
      </GeneralLayout>
    </>
  )
}

export default TheLoroBlonyo